/**
 * Configuration the IdP sign-in needs, read from the CRA build-time
 * environment (PASSGENAU_* variables are inlined by webpack).
 */

const idpBaseUrl = (process.env.PASSGENAU_IDP_BASE_URL ?? '').trim();

if (!idpBaseUrl && process.env.NODE_ENV !== 'test') {
  throw new Error(
    'Missing required environment variable PASSGENAU_IDP_BASE_URL. ' +
    'Set it in .env, then rebuild.'
  );
}

export const config = {
  idp: {
    // Trailing slashes are stripped: every path in idpClient starts with one.
    baseUrl: (idpBaseUrl || 'http://idp.test').replace(/\/+$/, ''),
  },
} as const;
